import { render, staticRenderFns } from "./product-details-add-to-cart-standalone.vue?vue&type=template&id=395b7d8a&"
import script from "./product-details-add-to-cart-standalone.vue?vue&type=script&lang=js&"
export * from "./product-details-add-to-cart-standalone.vue?vue&type=script&lang=js&"
import style0 from "./product-details-add-to-cart-standalone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports